import { render, staticRenderFns } from "./IgnoreConfirmationModal.vue?vue&type=template&id=714523a6&"
import script from "./IgnoreConfirmationModal.vue?vue&type=script&lang=js&"
export * from "./IgnoreConfirmationModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports